import React, { useEffect, useState } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import 'animate.css'
import { Link } from 'react-router-dom'
import shape1 from '../assets/Images/shapes/HomeContactRightThread-01.png'
import shape2 from '../assets/Images/shapes/HomeContactLeftThread.png'
import BookAppointmentDialog from './BookAnAppointmentDialogue'
export default function HomeContact() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true
    })
  }, [])
  return (
    <div className='max-w-[1340px] mx-auto py-[20px] px-[24px] md:px-[24px] xl:px-[0px]'>
      <div
        className='relative bg-verylightGreen rounded-[24px] lg:block hidden p-[30px] md:p-[180px] px-[20px] md:px-[64px] text-thickGreen text-center '
        style={{
          backgroundImage: `
            url(${shape1}), 
            url(${shape2})
          `,
          backgroundPosition: '100%, 0 0',
          backgroundRepeat: 'no-repeat, no-repeat',
          backgroundSize: 'auto, auto 100%'
        }}
      >
        <div className='flex justify-center flex-col items-center'>
          <h2
            className='  text-[36px] md:text-[58px] leading-[1.138em] font-heading text-thickGreen mb-[48px] max-w-[600px]'
            data-aos='fade-up'
          >
            Your Health - Our Priority Always ready to help you…
          </h2>
          <div className='sm:block md:flex md:space-x-4 space-y-4 md:space-y-0'>
            <button
              onClick={handleOpenDialog}
              className='bg-orange text-white px-6 py-6 rounded-full font-medium   font-body text-[20px] leading-[1.112em] 
             transition-all hover:duration-300 hover:bg-lightGreen  hover:bg-opacity-90  hover:-translate-y-1
              block md:inline-block  text-center'

            >
              Book an Appointment
            </button>

            <Link
              to='/our-medical-services'
              className='text-thickGreen px-12 py-3 rounded-full  font-medium border border-thickGreen bg-transparent flex justify-center items-center hover:bg-orange hover:text-white hover:border-none text-[20px] font-body leading-[1.112em]  transition-all hover:duration-300 hover:-translate-y-1'

            >
              Our Services
            </Link>
          </div>
        </div>
      </div>
      <div
        className='relative bg-verylightGreen rounded-[24px] lg:hidden block p-[30px] md:p-[180px] px-[20px] md:px-[64px] text-thickGreen text-center '
        style={{
          backgroundImage: `
            url(${shape1})  
          `,
          backgroundPosition: '100%, 0 0',
          backgroundRepeat: 'no-repeat, no-repeat',
          backgroundSize: 'auto, auto 100%'
        }}
      >
        <div className='flex justify-center flex-col items-center'>
          <h2
            className='font-bold text-[36px] md:text-[58px] leading-[1.138em] font-heading text-thickGreen mb-[48px] max-w-[600px]'
            data-aos='fade-up'
          >
            Your Health - Our Priority Always ready to help you…
          </h2>
          <div className='sm:block md:flex md:space-x-4 space-y-4 md:space-y-0'>
            <button
              onClick={handleOpenDialog}
              className='bg-orange text-white px-6 py-6 rounded-full font-medium   font-body text-[20px] leading-[1.112em] 
             transition-all hover:duration-300 hover:bg-lightGreen  hover:bg-opacity-90  hover:-translate-y-1
              block md:inline-block  text-center'
            >
              Book an Appointment
            </button>
            <Link
              to='/our-medical-services'
              className='text-thickGreen px-12 py-3 rounded-full  font-medium border border-thickGreen bg-transparent flex justify-center items-center hover:bg-orange hover:text-white hover:border-none text-[20px] font-body leading-[1.112em]  transition-all hover:duration-300 hover:-translate-y-1'
            >
              Our Services
            </Link>
          </div>
        </div>
      </div>
      <BookAppointmentDialog open={dialogOpen} onClose={handleCloseDialog} />
    </div>
  )
}
